import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import App from './App';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';
import CookieConsentBanner from './components/CookieConsentBanner';
import AppErrorBoundary from './components/AppErrorBoundary';
import SeoManager from './seo/SeoManager';
import { initializeAnalytics } from './utils/analytics';
import {
  applyTheme,
  getInitialTheme,
  getThemeScopeForPath,
} from './utils/theme';
import './index.css';
import './styles/Theme.css';
import './i18n';

const initialThemeScope = getThemeScopeForPath(
  window.location.pathname
);

applyTheme(getInitialTheme(initialThemeScope));

/*
 * Одноразовая миграция 2026-07-28 удалена.
 *
 * Обычный запуск приложения больше не:
 * - снимает регистрацию всех Service Worker;
 * - удаляет весь Cache Storage;
 * - перезагружает страницу.
 *
 * Это важно для FCM push и предсказуемого холодного старта.
 */

// Сначала выставляем Consent Mode, затем запускаем React.
// Без согласия Google Analytics не загружается.
initializeAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AppErrorBoundary>
    <BrowserRouter>
      <AnalyticsRouteTracker />
    <SeoManager />
    <App />
      <CookieConsentBanner />
    </BrowserRouter>
  </AppErrorBoundary>
);
